import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material'

function FigmaTable({ data, columns, fundoRoxo = false, onRowDoubleClick, hover = false }) {
    const container = {
        border: fundoRoxo ? '1px solid white' : '1px solid black',
        backgroundColor: fundoRoxo ? '#2B153E' : '#D9D9D9',
        color: fundoRoxo ? 'white' : 'black',
        padding: '0px 7px',
        // display: 'block',
        height: '100%',
        width: '100%'
    }

    const header = {
        height: '19px !important',
        padding: 0,
        margin: 0,
        backgroundColor: fundoRoxo ? '#2B153E' : '#D9D9D9',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    }

    const headerCell = {
        height: '19px !important',
        backgroundColor: fundoRoxo ? '#2B153E' : '#D9D9D9',
        borderBottom: fundoRoxo ? '1px solid white' : '1px solid black',
        color: fundoRoxo ? 'white' : 'black',
        fontSize: fundoRoxo ? '14px' : '12px',
        fontWeight: 600,
        padding: 0,
        margin: 0,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexGrow: 1,
        overflow: 'hidden'
    }

    const dataRow = {
        height: '19px !important',
        padding: 0,
        margin: 0,
        backgroundColor: fundoRoxo ? '#2B153E' : hover ? '' : '#D9D9D9',
        color: fundoRoxo ? 'white' : 'black',
        display: 'flex',
        overflowY: 'hidden'
    }

    const dataCell = {
        height: fundoRoxo ? '25px' : '19px !important',
        backgroundColor: fundoRoxo ? '#2B153E' : hover ? '' : '#D9D9D9',
        borderBottom: fundoRoxo ? '1px solid white' : '1px solid black',
        color: fundoRoxo ? 'white' : 'black',
        fontSize: fundoRoxo ? '12px' : '10px',
        fontWeight: 600,
        padding: 0,
        margin: 0,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexGrow: 1,
        overflow: 'hidden'
    }

    if (data.length === 0) {
        return (
            <TableContainer component={Paper} style={ container }>
                <Typography sx={{ color: fundoRoxo ? 'white' : 'black' }} fontSize="16px" fontWeight="600" textAlign="center" >Nenhum dado encontrado</Typography>
            </TableContainer>
        )
    }
    return (
        <TableContainer component={Paper} style={container}>
            <Table stickyHeader style={{
                // tableLayout: 'fixed',
                width: '100%',
                height: '100%',
                borderCollapse: "collapse",
                display: 'flex',
                flexDirection: 'column'
                // borderSpacing: "5px"
            } }>
                <TableHead>
                    <TableRow key="header" style={ header }>
                        {columns.map((column, index) => (
                            <TableCell key={index} style={column.style} sx={headerCell} >
                                {column.name}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody style={{
                    overflowY: 'auto'
                }}>
                    {data.map((row, index) => (
                        <TableRow
                            hover = {hover}
                            style={dataRow}
                            key={index}
                            onDoubleClick={() => onRowDoubleClick(row)}>
                            {columns.map((column, index) => {
                                return (
                                    <TableCell
                                        key={`${column.name}-${index}`}
                                        title={column.cell(row) == "[object Object]" ? "" : column.cell(row)}
                                        style={column.style}
                                        sx={dataCell}
                                    >
                                        {column.cell(row)}
                                    </TableCell>
                                )
                            })}
                            {/* <TableCell key={row[index][0]} title={row[index] == "[object Object]" ? "" : row[index]} style={dataCell}>
                                {row[index]}
                            </TableCell> */}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default FigmaTable
